import { useState, useRef, useEffect } from "react";
import styles from "./customDropdown.module.css"; // Import the CSS module for styling

export const CustomDropdown = ({
  options,
  fieldName,
  placeholder,
  handleFilterBy,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);
  const lastQueryRef = useRef(null); // Store last query

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    if (!isOpen) {
      setFilteredOptions(options); // Reset filter when opening dropdown
    }
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  // Close the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Handle filtering input change
  const handleFilterChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setFilteredOptions(
      options.filter((option) =>
        option.label.toLowerCase().includes(value.toLowerCase())
      )
    );

    const match = options.find((option) => option.label === value);

    if (match) {
      const query = { property: name, value: value };
      // Only call if different from last sent
      if (
        !lastQueryRef.current ||
        lastQueryRef.current.property !== name ||
        lastQueryRef.current.value !== value
      ) {
        handleFilterBy(query);
        lastQueryRef.current = query;
      }
    } else {
      // Only reset if last value wasn't ''
      if (lastQueryRef.current !== "") {
        handleFilterBy("");
        lastQueryRef.current = "";
      }
    }
  };
  useEffect(() => {
    if (selectedOption?.value) {
      handleFilterBy(selectedOption);
    } else {
      handleFilterBy({
        property: fieldName,
        value: "",
      });
    }
  }, [selectedOption, handleFilterBy, fieldName]);
  return (
    <div className={styles.custom_dropdown} ref={dropdownRef}>
      <div className={styles.dropdown_header} onClick={toggleDropdown}>
        {selectedOption && selectedOption.value
          ? selectedOption.value
          : placeholder}
        <span className={styles.arrow}>{isOpen ? "▲" : "▼"}</span>
      </div>
      {isOpen && (
        <div className={styles.dropdown_content}>
          <input
            type="text"
            name={fieldName}
            placeholder="Options..."
            className={styles.dropdown_filter}
            onChange={handleFilterChange}
          />
          <div className={styles.dropdown_list}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={index}
                  className={`${styles.dropdown_item} ${
                    selectedOption && selectedOption.value === option.value
                      ? styles.dropdown_item_selected
                      : ""
                  }`}
                  onClick={() =>
                    handleOptionClick({
                      property: fieldName,
                      value: option.value,
                    })
                  }
                >
                  {option.label}
                </div>
              ))
            ) : (
              <div className={styles.dropdown_item + " " + styles.no_results}>
                No result found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
